import * as React from 'react';
import { DeprecatedLink as Link } from '@lmn/design-system';
import type { DeprecatedLinkVariant as LinkVariant } from '@lmn/design-system';
import styled from 'styled-components';

type CallbackLinkProps = {
  onClick: (event: React.SyntheticEvent) => void;
  variant?: LinkVariant;
  appearance?: React.ComponentProps<typeof Link>['appearance'];
} & React.HTMLAttributes<HTMLElement>;

const StyledLink = styled(Link)`
  /* Ensure visible focus indicator for accessibility (WCAG 2.4.7) */
  outline: 2px solid transparent;
  outline-offset: 2px;

  &:focus-visible {
    outline: 2px solid ${(p) => p.theme.commons.colors.primary400};
    outline-offset: 2px;
    box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.25);
  }
`;

export function CallBackLink(props: CallbackLinkProps) {
  const { children, variant = 'accent', appearance = 'default', role, onClick, ...rest } = props;
  return (
    <StyledLink
      variant={variant}
      appearance={appearance}
      role={role}
      onKeyPress={onClick}
      onClick={onClick}
      tabIndex={0}
      {...rest}
    >
      {children}
    </StyledLink>
  );
}
